import { render, staticRenderFns } from "./allEmployees.vue?vue&type=template&id=5481d7c1"
import script from "./allEmployees.vue?vue&type=script&lang=js"
export * from "./allEmployees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports